import React, { useState } from 'react';
import logo from '../assets/images/newlogo.jpg';
import './Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(prev => !prev);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav>
      <Link to="/" className="nav-brand" aria-label="Ayurvedic Consultation Clinic Home">
        <img src={logo} alt="Ayurveda Leaf Logo" />
        Sudhamshu Ayurveda
      </Link>

      <div
        className="hamburger"
        onClick={toggleMenu}
        aria-label="Toggle Navigation"
        role="button"
        aria-expanded={isOpen}
        tabIndex="0"
      >
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      <ul className={`nav-items ${isOpen ? 'open' : ''}`} role="menubar" aria-label="Primary Navigation">
        <li role="none"><Link role="menuitem" to="/" onClick={closeMenu}>Home</Link></li>
        <li role="none"><Link role="menuitem" to="/about" onClick={closeMenu}>About</Link></li>
        <li role="none"><Link role="menuitem" to="/journal" onClick={closeMenu}>Journal</Link></li>
        <li role="none"><Link role="menuitem" to="/activities" onClick={closeMenu}>Activities</Link></li>
        <li role="none"><Link role="menuitem" to="/services" onClick={closeMenu}>Services</Link></li>
        <li role="none"><Link role="menuitem" to="/contact" onClick={closeMenu}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
